;(function () {
  const originalDocumentAddEventListener = document.addEventListener
  document.addEventListener = function (type, listener, options) {
    try {
      if (type === 'DOMContentLoaded' && document.readyState !== 'loading') {
        listener()
      } else {
        originalDocumentAddEventListener.call(document, type, listener, options)
      }
    } catch (e) {
      console.error(e)
    }
  }
})()
